import { render, staticRenderFns } from "./productAnalysis.vue?vue&type=template&id=1bc8940a&scoped=true"
import script from "./productAnalysis.vue?vue&type=script&lang=js"
export * from "./productAnalysis.vue?vue&type=script&lang=js"
import style0 from "./productAnalysis.vue?vue&type=style&index=0&id=1bc8940a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc8940a",
  null
  
)

export default component.exports